import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class BrandSignupCompanyInfoRoute extends Route {
  @service session;

  setupController(controller) {
    super.setupController(...arguments);
    controller.initFunnel.perform(this.session.currentUser);
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.initFunnel.cancelAll({ resetState: true });
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/brand/signup/step/company-info/');
  }
}

export default BrandSignupCompanyInfoRoute;
